'use strict';
// import controller from './smoothScroll.controller';
// import service from './smoothScroll.service';

function directive(smoothScrollService) {
    return {
        link,
        scope: {},
        restrict: 'A'
    };
    function link (scope, element, attrs) {
        element.bind('click', () => {
            smoothScrollService.smoothScroll(attrs.carsSmoothScroll);
        });
    }
}

directive.$inject = ['smoothScrollService'];

export default directive;
